import UserLoggedInGuard from '~/service_providers/authorization/guards/user_logged_in_guard'

const validators = {
  userLoggedIn: UserLoggedInGuard
}

export default validators
